import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type { ListResearchLibListsResT } from 'server/controllers/researchLib/listLinks';
import type * as SSM from 'server/services/researchLib';

import { P_API_RESEARCH_LIB_LINKS, type ResearchLibLinkT } from 'utils';

const ss = webpack.requireWeak<typeof SSM>('server/services/researchLib', import.meta.dirname);

export async function listResearchLibLinks():
Promise<ResearchLibLinkT[]> {
  if (ss) return ss.listResearchLibLinks();

  const res = await axios<ListResearchLibListsResT>(
    P_API_RESEARCH_LIB_LINKS,
  );

  return res.data;
}
